// ghost commit

import dynamic from 'next/dynamic'
import { withMicrositeProps } from '@dustin-web/microsite-nextjs/src/with-server-data/with-microsite-props'
import { withMicrositeWrapper } from '@dustin-web/microsite-nextjs/src/with-server-data/with-microsite-wrapper'

import { E4getServerSideProps } from '@productsite/src/components/search/pages/search'
const SearchPage = dynamic(() =>
  import('@productsite/src/components/search/pages/search').then(mod => mod.Page)
)

const Page = ({
  searchPhrase,
  isUserInitiated,
}: {
  searchPhrase: string
  isUserInitiated: boolean
}) => {
  return <SearchPage searchPhrase={searchPhrase} isUserInitiated={isUserInitiated} />
}

export const getServerSideProps = withMicrositeProps(
  async ({ micrositeProps }) => await E4getServerSideProps({ micrositeProps })
)

export default withMicrositeWrapper(Page, {})
